import i18n from 'i18next';
import React, {useMemo} from 'react';
import {OrganizationSelection, PersonSelection, SwList} from 'simplifyworks-core-ui';
import {connect} from 'react-redux';
import SwListCustomOverride from '../../core-override/SwListCustomOverride';
import {CountryWithFlag} from '../renderers/renderers';

const EmailList = (props) => {

	const organizationFixedFilter = useMemo(() => {
		return {
			organizationTypes: props?.nationalBodyCoreCodebook ? [props?.nationalBodyCoreCodebook] : []
		};
	}, [props?.nationalBodyCoreCodebook]);

	const countryFixedFilter = useMemo(() => {
		return {
			organizationTypes: props?.countryCoreCodebook ? [props?.countryCoreCodebook] : []
		};
	}, [props?.countryCoreCodebook]);

	return <>
		<SwList
			name="foedus-contacts-emails-list"
			restPrefix="/api/foedus/emails"
			removable={false}
			defaultOrdering={[{property: 'email', order: 'asc'}]}
			fixedFilter={{
				sendNotifications: true
			}}
		>
			<SwList.Table minWidth="480px">
				<SwList.String
					property="email"
					labelKey="foedus-email"
					filterable
					orderable={false}
				/>

				<SwList.Entity
					property='foedusPerson.person'
					pathProperty='foedusPerson.id'
					labelKey='core-person-niceLabel'
					filterable={true}
					pathFunc={resource => '/contacts/people/' + resource.foedusPerson.id}
					render={PersonSelection.renderExtendedText}
				>
					{PersonSelection.renderSelection({
						name: 'core-person-niceLabel'
					})}
				</SwList.Entity>

				<SwList.Entity
					property='foedusPerson.organization'
					labelKey='core-organization'
					filterable={true}
					orderable={false}
					render={OrganizationSelection.renderText}
					pathFunc={resource => '/contacts/organizations/' + resource?.foedusPerson?.foedusOrganizationId + '/base-info'}
				>
					{OrganizationSelection.renderSelection({
						name: 'core-organization',
						fixedFilter: organizationFixedFilter
					})}
				</SwList.Entity>

				<SwList.Entity
					property='foedusPerson.country'
					labelKey='foedus-country'
					filterable
					orderable={false}
					render={(resource) => <CountryWithFlag
						code={resource?.code}
						name={resource?.name ?? resource?.nameEng}
					/>}
					renderHeadFilter={(resource) => resource?.name ?? resource?.nameEng}
				>
					{OrganizationSelection.renderSelection({
						name: 'foedus-country',
						fixedFilter: countryFixedFilter
					})}
				</SwList.Entity>

				<SwListCustomOverride
					property="foedusPerson.phones"
					labelKey="foedus-phone"
					filterable
					orderable={false}
					render={(resource) => {
						return (<div>
							{resource?.foedusPerson?.phones?.map(p => {
								const phonePrefix = p?.country?.fieldValuesMap?.phonePrefix;
								return (phonePrefix ? phonePrefix : '') + ' ' + p.phone;
							})?.join(', ')}
						</div>);
					}}
				/>

			</SwList.Table>

			<SwList.Info />
			<SwList.Pagination />

		</SwList>
	</>;
};

const mapStateToProps = (state) => {
	return {
		nationalBodyCoreCodebook: state?.foedus?.nationalBodyCoreCodebook,
		countryCoreCodebook: state?.foedus?.countryCoreCodebook
	};
};

export default {
	title: () => i18n.t('foedus-contacts-emails-title-list'),
	main: connect(mapStateToProps)(EmailList)
};
